@if (!(unitCount === 0 && (searchStr || filter !== 'all'))) {
  <mat-expansion-panel
    class="panel mat-elevation-z0"
    (afterExpand)="expand()"
    (afterCollapse)="collapse()"
    >
    <mat-expansion-panel-header>
      <mat-panel-title
        class="panel-title"
        [style.font-weight]="selectedUnitIdListByUser.length > 0 ? 'bolder' : 'normal'"
        >
        <mat-icon>person</mat-icon>
        <span>&nbsp;&nbsp;{{ user.name }}:&nbsp;&nbsp;</span>
        <span matTooltip="{{ 'message.tooltip.selected-in-total' | translate }}">
          {{ selectedUnitIdListByUser.length > 0 ? selectedUnitIdListByUser.length + ' / ' : '' }}{{ unitCount }}
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <mat-expansion-panel class="sub-panel mat-elevation-z0"
        [togglePosition]="'before'"
        [expanded]="searchStr || filter !== 'all'"
        >
        <mat-expansion-panel-header class="header">
          <mat-panel-title class="panel-title">
            <span>&nbsp;&nbsp;{{ 'term.all-units' | translate }}:&nbsp;&nbsp;</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <app-unit-list [units]="unitsByUserFiltered"
          ></app-unit-list>
        </ng-template>
      </mat-expansion-panel>
      @for (groupView of groupViews; track groupView.group.id) {
        <div>
          <mat-expansion-panel class="sub-panel mat-elevation-z0"
            [togglePosition]="'before'"
            [expanded]="searchStr || filter !== 'all'"
            >
            <mat-expansion-panel-header class="header">
              <mat-panel-title class="panel-title">
                <mat-icon [ngStyle]="{'color': groupView.group.color }">label</mat-icon>
                <span>&nbsp;&nbsp;{{ groupView.group.name }}:&nbsp;&nbsp;{{ groupView.selectedCountLabel }} {{ groupView.units.length }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <app-unit-list [units]="groupView.units"
              ></app-unit-list>
            </ng-template>
          </mat-expansion-panel>
        </div>
      }
    </ng-template>
  </mat-expansion-panel>
}
